<template>
    <div class="flex grow">
        <div>
            <CoreIcon
                :name="icon"
                :class="`text-${message.severity}`"
                class="mr-3"
            ></CoreIcon>
        </div>
        <article class="flex flex-col py-1">
            <h3 class="pb-3">{{ title }}</h3>
            <div class="toast-content">{{ messageContent }}</div>
        </article>
    </div>
</template>

<script>
import CoreIcon from '@/components/core/CoreIcon.vue'

export default {
    name: 'ToastTemplate',

    components: {
        CoreIcon,
    },

    props: {
        message: {
            type: Object,
            default: null,
        },
    },

    computed: {
        title() {
            switch (this.message.severity) {
                case 'success':
                    return this.$t('ui.notification_heading_success')

                case 'warning':
                    return this.$t('ui.notification_heading_warning')

                case 'error':
                    return this.$t('ui.notification_heading_error')

                default:
                    return this.$t('ui.notification_heading_info')
            }
        },

        icon() {
            switch (this.message.severity) {
                case 'success':
                    return 'checkbox-marked-circle-outline'

                case 'warning':
                    return 'alert-circle-outline'

                case 'error':
                    return 'alert-circle-outline'

                default:
                    return 'information-outline'
            }
        },

        // params fill the placeholders of a translation key sent by the API, e.g. {contract}.
        messageContent() {
            return this.message.params
                ? this.$t(this.message.detail, this.message.params)
                : this.$t(this.message.detail)
        },
    },
}
</script>

<style>
.toast-content {
    display: flex;
}
</style>
